import { DEFAULT_LAYOUT, SLOT_COUNT, WIDGET_IDS, normalizeWidgetLayout } from './marketWidgetLayout.js'
const overlap=(a,b)=>a.slot<b.slot+b.span&&b.slot<a.slot+a.span
export function dockWidget(layout,id,slot,span) {
  const current=layout.find(w=>w.id===id),width=span??current?.span??1
  if(!WIDGET_IDS.includes(id)||!Number.isInteger(slot)||![1,2].includes(width)||slot<0||slot+width>SLOT_COUNT)return null
  for(const direction of [1,-1]) {
    const placed=[{id,slot,span:width}]
    const rest=layout.filter(w=>w.id!==id).map(w=>({...w})).sort((a,b)=>direction*(a.slot-b.slot))
    let failed=false
    for(const w of rest){
      while(placed.some(v=>overlap(v,w)))w.slot+=direction
      if(w.slot<0||w.slot+w.span>SLOT_COUNT){failed=true;break}
      placed.push(w)
    }
    if(!failed)return placed.sort((a,b)=>a.slot-b.slot)
  }
  return null
}
export function readDockLayout(stored) {
  if(stored?.version===2)return normalizeWidgetLayout(stored.value)
  if(stored?.version!==1||!Array.isArray(stored.value))return DEFAULT_LAYOUT
  const layout=normalizeWidgetLayout(stored.value.map(w=>({...w,slot:w.slot*2})))
  // Keep an intentionally empty header empty; otherwise make the new indicator discoverable.
  if(layout.length&&!layout.some(w=>w.id==='fomo')){
    const free=Array.from({length:SLOT_COUNT},(_,slot)=>slot).find(slot=>!layout.some(w=>slot>=w.slot&&slot<w.slot+w.span))
    if(free!==undefined)layout.push({id:'fomo',slot:free,span:1})
  }
  return layout
}
export function fomoReading({snapshot,loading=false,failed=false}={},now=Date.now()) {
  const value=typeof snapshot?.value==='number'&&Number.isFinite(snapshot.value)&&snapshot.value>=0&&snapshot.value<=100?snapshot.value:null
  const age=now-Date.parse(snapshot?.observed_at)
  const current=value!==null&&!loading&&!failed&&['available','source_time_unknown'].includes(snapshot?.status)&&snapshot.collection_current===true&&age>=0&&age<=1500000
  return {value,current,tone:value!==null?(value<=25?'green':value>75?'red':'yellow'):'muted',
    label:loading?'Loading…':failed?'Feed unavailable':snapshot?.status==='collection_failed'?'Collection failed':value===null?'No reading':current?'Observed':'Last reading',observedAt:snapshot?.observed_at||null}
}
